export default __webpack_public_path__ + "static/media/spinner.3a3d32d4.gif";